import {
  registerCustomerRequestedType,
  signInCustomerRequestedType
} from '@spa/lib/store/auth/authSlice';
import { apiAuthRefreshTokenRequestedType } from '../../../api/auth/refreshApi';
import refreshTokenSaga from './refreshTokenSaga';
import registerCustomerSaga from '@spa/lib/store/sagas/api/auth/registerCustomerSaga';
import signInCustomerSaga from '@spa/lib/store/sagas/api/auth/signInCustomerSaga';
import { takeEvery } from 'typed-redux-saga';

function* authApiSaga(): Generator {
  yield* takeEvery(apiAuthRefreshTokenRequestedType, refreshTokenSaga);
  yield* takeEvery(registerCustomerRequestedType, registerCustomerSaga);
  yield* takeEvery(signInCustomerRequestedType, signInCustomerSaga);
}

export default authApiSaga;
